module.exports = __webpack_public_path__ + "img/logic.1eb65787.jpeg";